module.exports = __webpack_public_path__ + "media/country_flags/td-d63fcd08.png";